
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/abc-podatkow/strona/[strona]",
      function () {
        return require("private-next-pages/abc-podatkow/strona/[strona].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/abc-podatkow/strona/[strona]"])
      });
    }
  